import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f687af8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 text-weight-500" }, "事業所連絡", -1))
const _hoisted_2 = { class: "bg-white border border-outline-color round-4 mb-3 px-3 mt-1" }
const _hoisted_3 = { class: "d-flex align-items-center text-size-14" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "キャンセル", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "緊急連絡先", -1))
const _hoisted_6 = { class: "px-3 pb-3" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 0,
  class: "text-pre-wrap mt-2"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 text-weight-500" }, "お仕事情報", -1))
const _hoisted_11 = { class: "bg-white border border-outline-color round-4 mb-3 px-3 mt-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "お仕事詳細", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "申込条件・持ち物", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "住所（地図アプリを起動）", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "労働条件通知書", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 text-weight-500" }, "その他", -1))
const _hoisted_17 = { class: "bg-white border border-outline-color round-4 mb-3 px-3 mt-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "お気に入り事業所に登録", -1))
const _hoisted_19 = {
  key: 1,
  class: "d-flex fixed-bottom border-top border-gray-04 footer-button-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppBadge = _resolveComponent("AppBadge")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["section2 px-3 pt-4 mt-2 bg-white footer-button-box-parent", 
      _ctx.showsAttendanceCorrection || _ctx.isShowsEvaluationButton
        ? 'footer-button-box-parent'
        : ''
    ])
  }, [
    _hoisted_1,
    _createTextVNode(),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterLink, {
        to: {
          name: 'MessageRoomDetail',
          params: {
            officeId: _ctx.application.order.office.id
          }
        },
        class: "d-flex justify-content-between align-items-center border-outline-color py-3"
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_3, [
            _createTextVNode("\n          メッセージ\n          "),
            (!_ctx.isSentMessage)
              ? (_openBlock(), _createBlock(_component_AppBadge, {
                  key: 0,
                  class: "ml-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("\n            要挨拶\n          ")
                  ], undefined, true),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createTextVNode(),
          _createVNode(_component_FeatherIcon, {
            icon: "chevron-right",
            size: "1x",
            class: "text-gray-05 ml-2"
          })
        ], undefined, true),
        _: 1
      }, 8, ["to"]),
      _createTextVNode(),
      (_ctx.application && _ctx.application.status === 'applied')
        ? (_openBlock(), _createBlock(_component_RouterLink, {
            key: 0,
            to: _ctx.cancelRoute,
            class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(),
              _createVNode(_component_FeatherIcon, {
                icon: "chevron-right",
                size: "1x",
                class: "text-gray-05 ml-2"
              })
            ], undefined, true),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createTextVNode(),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowEmergencyContactModal = true)),
        class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3",
        role: "button"
      }, [
        _hoisted_5,
        _createTextVNode(),
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-right",
          size: "1x",
          class: "text-gray-05 ml-2"
        })
      ]),
      _createTextVNode(),
      _createVNode(_component_BModal, {
        modelValue: _ctx.isShowEmergencyContactModal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShowEmergencyContactModal) = $event)),
        title: "緊急連絡先",
        "hide-footer": "",
        centered: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, "事業所名：" + _toDisplayString(_ctx.application.order.office.name), 1),
            _createTextVNode(),
            _createElementVNode("p", null, "担当者：" + _toDisplayString(_ctx.application.order.office.staffName), 1),
            _createTextVNode(),
            _createElementVNode("p", null, [
              _createTextVNode("\n            電話番号："),
              _createElementVNode("a", {
                href: 'tel:' + _ctx.application.order.office.phoneNumber,
                class: "text-blue"
              }, _toDisplayString(_ctx.application.order.office.phoneNumber), 9, _hoisted_7)
            ]),
            _createTextVNode(),
            (_ctx.application.order.office.emergencyContact)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.application.order.office.emergencyContact), 1))
              : _createCommentVNode("", true),
            _createTextVNode(),
            _createElementVNode("a", {
              href: 'tel:' + _ctx.application.order.office.phoneNumber
            }, [
              _createVNode(_component_AppButton, {
                variant: "green",
                block: true,
                class: "d-block mt-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("電話をする")
                ], undefined, true),
                _: 1
              })
            ], 8, _hoisted_9)
          ])
        ], undefined, true),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createTextVNode(),
    _hoisted_10,
    _createTextVNode(),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_RouterLink, {
        to: {
          name: 'OrdersDetail',
          params: {
            orderId: _ctx.application.order.id
          },
          query: {
            transitionSource: 'ApplicationDetail'
          }
        },
        class: "d-flex justify-content-between align-items-center border-outline-color py-3"
      }, {
        default: _withCtx(() => [
          _hoisted_12,
          _createTextVNode(),
          _createVNode(_component_FeatherIcon, {
            icon: "chevron-right",
            size: "1x",
            class: "text-gray-05 ml-2"
          })
        ], undefined, true),
        _: 1
      }, 8, ["to"]),
      _createTextVNode(),
      _createVNode(_component_RouterLink, {
        to: {
          name: 'OrdersDetail',
          params: {
            orderId: _ctx.application.order.id
          },
          query: {
            transitionSource: 'ApplicationDetail'
          },
          hash: '#applicationCondition'
        },
        class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
      }, {
        default: _withCtx(() => [
          _hoisted_13,
          _createTextVNode(),
          _createVNode(_component_FeatherIcon, {
            icon: "chevron-right",
            size: "1x",
            class: "text-gray-05 ml-2"
          })
        ], undefined, true),
        _: 1
      }, 8, ["to"]),
      _createTextVNode(),
      _createElementVNode("a", {
        class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3",
        role: "button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showMap && _ctx.showMap(...args)))
      }, [
        _hoisted_14,
        _createTextVNode(),
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-right",
          size: "1x",
          class: "text-gray-05 ml-2"
        })
      ]),
      _createTextVNode(),
      _createVNode(_component_RouterLink, {
        to: {
          name: 'NoticeOfEmploymentsList',
          params: {
            applicationId: _ctx.application.id
          }
        },
        class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
      }, {
        default: _withCtx(() => [
          _hoisted_15,
          _createTextVNode(),
          _createVNode(_component_FeatherIcon, {
            icon: "chevron-right",
            size: "1x",
            class: "text-gray-05 ml-2"
          })
        ], undefined, true),
        _: 1
      }, 8, ["to"])
    ]),
    _createTextVNode(),
    (_ctx.favoriteOffice == null || !_ctx.favoriteOffice.isFavorite)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_16,
          _createTextVNode(),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openConfirmFavoriteOffice && _ctx.openConfirmFavoriteOffice(...args))),
              role: "button",
              class: "d-flex justify-content-between align-items-center border-outline-color py-3"
            }, [
              _hoisted_18,
              _createTextVNode(),
              _createVNode(_component_FeatherIcon, {
                icon: "chevron-right",
                size: "1x",
                class: "text-gray-05 ml-2"
              })
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.showsAttendanceCorrection || _ctx.isShowsEvaluationButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          (_ctx.showsAttendanceCorrection)
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 0,
                block: "",
                variant: "outline-gray-04",
                class: "mx-2 my-3 bg-white text-black footer-button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_RouterLink, {
                    to: {
            name: _ctx.attendanceCorrectionToName,
            params: {
              applicationId: _ctx.application.id
            }
          },
                    class: "text-size-14 d-block footer-button-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("\n          勤怠変更\n          "),
                      _createVNode(_component_AppBadge, {
                        class: "ml-1",
                        variant: _ctx.attendanceCorrectionAppBadgeVariant
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.attendanceCorrectionAppBadgeText), 1)
                        ], undefined, true),
                        _: 1
                      }, 8, ["variant"])
                    ], undefined, true),
                    _: 1
                  }, 8, ["to"])
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createTextVNode(),
          (_ctx.isShowsEvaluationButton)
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 1,
                block: "",
                class: "mx-2 my-3 footer-button"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_RouterLink, {
                    to: {
            name: 'ApplicationEvaluation',
            params: {
              applicationId: _ctx.application.id
            }
          },
                    class: "text-size-14 d-block footer-button-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("\n          評価\n        ")
                    ], undefined, true),
                    _: 1
                  }, 8, ["to"])
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}